/**
 * Task → Phase transition mapping
 *
 * Maps task_code values to the phase_type_code they transition INTO when completed.
 * Completing a task with a linked phase type triggers a phase boundary report
 * at today's date instead of requiring a manual report pin click.
 *
 * 'support' is intentionally omitted — it is maintenance within maturing, not a
 * phase transition marker.
 */
export const TASK_PHASE_TRANSITION_MAP = {
  sow_indoor:         'germination',
  sow_outdoor:        'germination',
  transplant_indoor:  'seedling',
  transplant_outdoor: 'maturing',
  compost:            'decomposition',
}
